export default __webpack_public_path__ + "static/media/google-drive-icon.d06956d9.png";